// One person can hold several roles: `role` is their primary role and
// `extra_roles` are the additional ones. Access is the UNION of all of them.
export const rolesOf = (u) => {
  const out = [];
  [u?.role, ...(u?.extra_roles || [])].forEach((r) => { if (r && !out.includes(r)) out.push(r); });
  return out;
};

// True if the person holds ANY of the given roles (pass several, or one array).
export const hasRole = (u, ...roles) => {
  const wanted = roles.flat();
  return rolesOf(u).some((r) => wanted.includes(r));
};

export const ADMIN_LEVEL = ["super_admin", "major_admin", "admin"];
export const isAdminLevel = (u) => hasRole(u, ADMIN_LEVEL);

// "salesperson + karigar" — for display next to a name.
export const roleLabel = (u, sep = " + ") =>
  rolesOf(u).map((r) => r.replace(/_/g, " ")).join(sep);
